import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import AvisoDiv from "./div";
/**
 * @deprecated use SecondaryNavLayout
 */
class Aviso extends React.PureComponent {
    render() {
        return (_jsxs("div", { children: [_jsxs(AvisoDiv, { show: !!this.props.renderNav, children: [_jsx("div", { className: "navbar-secondarynav fixed", role: "navigation", children: this.props.renderNav() }), _jsx("div", { className: "secondary-nav-height" })] }), _jsx("div", { className: "container-fluid py-3 bg-light", style: { minHeight: "100%" }, children: this.props.children })] }));
    }
}
export default Aviso;
